import { orchestrator } from 'satcheljs';
import {
    openNewFormToDuplicate,
    presentDiscardClosureConfirmation,
} from 'owa-calendar-compose-form-actions';
import { lazyDuplicateEvent } from 'owa-calendar-duplicate-event';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { isFTDFSeriesMaster } from 'owa-calendar-event-capabilities';
import { isInDeeplinkPopOutWindow } from 'owa-calendar-compose-form-store/lib/selectors/popoutSelectors';

orchestrator(openNewFormToDuplicate, actionMessage => {
    const { formId, targetWindow } = actionMessage;
    const event = getComposeEvent(formId);
    const isDeeplinkPopout = isInDeeplinkPopOutWindow(formId);

    presentDiscardClosureConfirmation(formId, targetWindow, () => {
        lazyDuplicateEvent.importAndExecute(
            event.ItemId,
            'ComposeCommandBarDuplicate',
            isFTDFSeriesMaster(event) /* shouldDuplicateThisAndFollowing */,
            isDeeplinkPopout /* isDeeplinkPopout */
        );
    });
});
